var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('branded-reset-password',{staticClass:"q-mt-xl",attrs:{"brand":_vm.brand,"brand-icon":_vm.brandData.logo,"base":_vm.base,"back-page":_vm.brandRouteName(_vm.brand, 'Login')}})}
var staticRenderFns = []

export { render, staticRenderFns }